module.exports = __webpack_public_path__ + "e2feb32aa105362f5419a0de6ff728db.svg";